<template>
  <div class="home">
    <div class="home-nav">
      <a href="/">
        <img
          alt="洪恩教育"
          src="https://assets.hongen.com/wp-content/themes/base-hongen/img/logo.png"
        />
      </a>
    </div>
    <div class="home-notice">
      <p class="home-notice-em">本页面的下载资源适用的洪恩点读笔型号为 TTP-718 WiFi版。</p>
      <p>如果您的洪恩点读笔型号是 TTP-818、TTP-A1，请进入<a href="https://www.hongen.com/downloads/ttp818/">TTP-818、TTP-A1 下载页面</a>。</p>
      <p>如果您的洪恩点读笔型号是 HT-100、 TTP-120 / 216 / 218 / 226 / 316 / 316A / 318 / 318A / 416 / 518 / 618 / 718(老款)型号的点读笔，请<a href="https://www.hongen.com/downloads/my-reader/">点击这里</a>。</p>
      <p>如果您的洪恩点读笔型号是 TTP-210、TTP-220，请进入<a href="https://www.hongen.com/downloads/my-reader/legacy-pens/">洪恩 TTP-210、TTP-220 点读笔下载说明</a>。</p>
    </div>
    <div class="home-breadcrumbs">
      <a href="/">洪恩教育</a> &gt; <a href="/downloads">下载中心</a> &gt; 洪恩点读笔 TTP-718 资源下载
    </div>
    <p class="home-title">TTP-718 WiFi版固件下载</p>
    <table class="home-firmware">
      <thead>
        <tr>
          <th>下载</th>
          <th>适用</th>
          <th>版本</th>
          <th>文件大小</th>
          <th>说明</th>
        </tr>
      </thead>
      <tbody>
        <tr
          v-for="(firmware, index) of firmwareList"
          :key="index"
        >
          <td class="home-firmware-download">
            <a
              :href="firmware.version_url"
              target="_blank"
            >
              下载
            </a>
          </td>
          <td class="home-firmware-type">
            <img
              src="@/assets/ttp718_s.png"
              width="64"
              height="72"
              alt="风暴"
            />
          </td>
          <td class="home-firmware-version">
            {{ firmware.version }}
          </td>
          <td class="home-firmware-size">
            {{ byteToMegaByte(firmware.version_length) }}MB
          </td>
          <td class="home-firmware-description">
            下载成功后，将解压出来的两个文件一起放入到点读笔的update目录，然后开机重启，等待完成升级。
          </td>
        </tr>
      </tbody>
    </table>
    <p class="home-title">点读资源下载</p>
    <div class="home-series">
      <label for="seriesSelect" class="home-series-left">
        图书系列：
        <select
          v-model="currentSeries"
          name="seriesSelect"
          @change="selectSeries"
        >
          <option value="">全部</option>
          <option
            v-for="(series, index) of seriesList"
            :key="index"
            :value="series"
          >
            {{ series }}
          </option>
        </select>
      </label>
      <label for="bookName" class="home-series-right">
        图书名称：
        <input
          v-model="bookName"
          name="bookName"
          type="text"
        />
        <button
          @click="searchBook"
        >
          搜索
        </button>
      </label>
    </div>
    <table class="home-books">
      <thead>
        <tr>
          <th>下载</th>
          <th>文件名</th>
          <th>文件大小</th>
          <th>文件描述</th>
        </tr>
      </thead>
      <tbody>
        <tr
          v-for="(book, index) of bookListResult.list"
          :key="index"
        >
          <td class="home-books-download">
            <a
              :href="book.bookUrl"
              target="_blank"
            >
              下载
            </a>
          </td>
          <td class="home-books-name">
            {{ book.filename }}
          </td>
          <td class="home-books-size">
            {{ book.resourceLength ? book.resourceLength.toFixed(2) : 0 }}MB
          </td>
          <td>
            {{ book.subtitle === book.bookName ? book.subtitle
                                                : `${book.subtitle} ${book.bookName}` }}
          </td>
        </tr>
      </tbody>
    </table>
    <div>
      <div class="button-group">
        <button
          :disabled="bookListResult.firstPageFlag"
          @click="goFirstPage"
        >
          &lt;&lt;
        </button>
        <button
          :disabled="!bookListResult.previousPageFlag"
          @click="goPrevPage"
        >
          &lt;
        </button>
        <span>
          {{ bookListResult.currentPage }} / {{ bookListResult.totalPage }}
        </span>
        <button
          :disabled="!bookListResult.nextPageFlag"
          @click="goNextPage"
        >
          &gt;
        </button>
        <button
          :disabled="bookListResult.lastPageFlag"
          @click="goLastPage"
        >
          &gt;&gt;
        </button>
      </div>
    </div>
    <div class="home-footer">
      <p>© 1996-2023 北京金洪恩教育科技有限公司. All Rights Reserved.</p>
      <p>
        <a href="http://www.beian.miit.gov.cn" target="_blank">京ICP备20018943号-2</a>
        <span>京公网安备11010802020328号</span>
        <span>出版物经营许可证，新出发京批字第直190305号</span>
      </p>
    </div>
  </div>
</template>

<script>
import api from '@/lib/api';

export default {
  name: 'HomeView',
  data() {
    return {
      seriesList: [],
      currentSeries: '',
      bookListResult: {
        currentPage: 1,
        list: [],
        pageSize: 10,
        total: 0,
        totalPage: 0,
        firstPageFlag: false,
        lastPageFlag: false,
        nextPageFlag: false,
        previousPageFlag: false,
      },
      firmwareList: [],
      bookName: '',
    };
  },
  mounted() {
    api.getSeriesList('talkypen-718').then((res) => {
      this.seriesList = res.data;
    });
    api.getFirmwareList('talkypen-718').then((res) => {
      this.firmwareList = res.data || [];
    });
    this.getBookList(this.currentSeries, this.bookName, this.bookListResult.currentPage);
  },
  methods: {
    getBookList(series, keyword, page) {
      api.getBookList('talkypen-718', series, keyword, page).then((res) => {
        if (res.code === 200) {
          if (res.data) {
            this.bookListResult.currentPage = res.data.current_page || 1;
            this.bookListResult.firstPageFlag = res.data.first_page_flag;
            this.bookListResult.lastPageFlag = res.data.last_page_flag;
            this.bookListResult.list = res.data.list || [];
            this.bookListResult.nextPageFlag = res.data.next_page_flag;
            this.bookListResult.pageSize = res.data.page_size;
            this.bookListResult.previousPageFlag = res.data.previous_page_flag;
            this.bookListResult.total = res.data.total;
            this.bookListResult.totalPage = res.data.total_page || 1;
          }
        }
      });
    },
    goFirstPage() {
      this.getBookList(this.currentSeries, this.bookName, 1);
    },
    goLastPage() {
      if (this.bookListResult.totalPage === 0) {
        return;
      }
      this.getBookList(this.currentSeries, this.bookName, this.bookListResult.totalPage);
    },
    goPrevPage() {
      if (this.currentPage === 1) {
        return;
      }
      this.getBookList(this.currentSeries, this.bookName, this.bookListResult.currentPage - 1);
    },
    goNextPage() {
      if (this.currentPage === this.bookListResult.totalPage) {
        return;
      }
      this.getBookList(this.currentSeries, this.bookName, this.bookListResult.currentPage + 1);
    },
    searchBook() {
      this.currentSeries = '';
      this.getBookList(this.currentSeries, this.bookName, 1);
    },
    selectSeries() {
      this.bookName = '';
      this.getBookList(this.currentSeries, this.bookName, 1);
    },
    byteToMegaByte(byte) {
      return (byte / 1024 / 1024).toFixed(2);
    },
  },
};
</script>

<style lang="scss" scoped>
.home {
  font-size: 14px;
  margin: 10px auto;
  max-width: 1170px;
  text-align: left;

  &-nav {
    height: 60xp;

    a {
      color: #333;
      display: inline-block;
      height: 60px;
      line-height: 60px;
      margin-right: 10px;
      padding: 0 10px;
      text-decoration: none;

      img {
        height: 40px;
        margin-right: 10px;
        vertical-align: middle;
      }
    }
  }

  &-notice {
    background-color: #F8EDA3;
    box-shadow: 0 1px 3px #C7A27A;

    &>p {
      margin: 4px;

      &>a {
        color: #A8760B;
        text-decoration: underline;
        font-weight: bold;
      }
    }

    &-em {
      font-weight: bold;
    }
  }

  &-breadcrumbs {
    color: #333;
    margin: 10px 0;

    &>a {
      color: #333;
      text-decoration: none;
    }
  }

  &-series {
    margin: 10px 0;

    &>label {
      margin-bottom: 10px;
    }

    &-left {
      float: left;
    }

    &-right {
      float: right;
    }

    select {
      border: 1px solid #ccc;
      border-radius: 3px;
      height: 24px;
      padding: 0 3px;
      max-width: 200px;
    }

    input {
      border: 1px solid #ccc;
      border-radius: 3px;
      height: 22px;
      margin-right: 10px;
      width: 140px;
    }

    button {
      background-color: #ddd;
      border: 1px solid #ccc;
      border-radius: 3px;
      color: #333;
      height: 30px;
      width: 48px;
    }
  }

  &-title {
    font-size: 18px;
    font-weight: bold;
    margin: 20px 0 10px 0;
  }

  &-books, &-firmware {
    border-collapse: collapse;
    width: 100%;

    &>thead {
      font-weight: bold;

      &>tr {
        &>th {
          border: 1px solid #ccc;
          padding: 5px 10px;
          text-align: center;
        }
      }
    }

    &>tbody {
      &>tr {
        &>td {
          border: 1px solid #ccc;
          padding: 5px 10px;
        }
      }
    }

    &-download {
      text-align: center;
      width: 50px;

      &>a {
        color: #333;
        text-decoration: none;

        &:hover {
          background-color: #ddd;
        }
      }
    }

    &-name {
      width: 120px;
      text-align: center;
    }

    &-size {
      text-align: right;
      width: 80px;
    }

    &-version {
      text-align: center;
      width: 60px;
    }

    &-type {
      padding: 5px;
      text-align: center;
      width: 90px;
    }

    &-description {
      white-space: pre-line;
    }
  }

  &-footer {
    margin: 20px 0;
    text-align: left;

    a {
      color: #333;
      display: inline-block;
      margin-right: 20px;
      text-decoration: none;
    }

    span {
      display: inline-block;
      margin-right: 20px;
    }
  }
  .button-group {
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 10px 0;

    button {
      background-color: #ddd;
      border: 1px solid #ccc;
      color: #333;
      margin: 0 5px;

      &:disabled {
        background-color: #eee;
        border-color: #eee;
        color: #ccc;
      }
    }
  }
}
</style>
